"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCouponToPackageApi = addCouponToPackageApi;
exports.batchUpdateCouponQuantitiesApi = batchUpdateCouponQuantitiesApi;
exports.checkPackageDeletableApi = checkPackageDeletableApi;
exports.closeCouponsApi = closeCouponsApi;
exports.companyappAutoListApi = companyappAutoListApi;
exports.couponLists = couponLists;
exports.couponPackageDetailApi = couponPackageDetailApi;
exports.couponPackageListApi = couponPackageListApi;
exports.couponPackageRelationsApi = couponPackageRelationsApi;
exports.couponsPageApi = couponsPageApi;
exports.couponslistApi = couponslistApi;
exports.createCouponPackageApi = createCouponPackageApi;
exports.createCouponsApi = createCouponsApi;
exports.deleteCouponPackageApi = deleteCouponPackageApi;
exports.deleteCouponsApi = deleteCouponsApi;
exports.detailCouponsApi = detailCouponsApi;
exports.downloadCouponCodesApi = downloadCouponCodesApi;
exports.exportReceiveRecordApi = exportReceiveRecordApi;
exports.getAllCouponPackagesApi = getAllCouponPackagesApi;
exports.getCustomersApi = getCustomersApi;
exports.getMealBrandsApi = getMealBrandsApi;
exports.getOneCardProductsApi = getOneCardProductsApi;
exports.getProductTypeDictApi = getProductTypeDictApi;
exports.getRenshouMerchantsApi = getRenshouMerchantsApi;
exports.getRenshouStoresApi = getRenshouStoresApi;
exports.getSelfOperatedCardProductsApi = getSelfOperatedCardProductsApi;
exports.getStationListApi = getStationListApi;
exports.getVerificationMerchantsApi = getVerificationMerchantsApi;
exports.getVerificationStoresApi = getVerificationStoresApi;
exports.getVoucherTypeDictApi = getVoucherTypeDictApi;
exports.importFakeCouponRecordApi = importFakeCouponRecordApi;
exports.linkInfoApi = linkInfoApi;
exports.receiveRecordApi = receiveRecordApi;
exports.receiveRecordDetailApi = receiveRecordDetailApi;
exports.removeCouponFromPackageApi = removeCouponFromPackageApi;
exports.retryGenerateCouponCodesApi = retryGenerateCouponCodesApi;
exports.skuListApi = skuListApi;
exports.statisticsApi = statisticsApi;
exports.updateCouponPackageApi = updateCouponPackageApi;
exports.updateCouponQuantityApi = updateCouponQuantityApi;
exports.updateCouponsApi = updateCouponsApi;
var _request = _interopRequireDefault(require("@/utils/request"));
var _index = require("@/utils/index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * 查询优惠券领用记录
 */
function receiveRecordApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/receiveRecord",
    method: 'GET',
    params: params
  });
}

/**
 * 查询优惠券领用记录详情
 */
function receiveRecordDetailApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/receiveRecord/".concat(params),
    method: 'GET'
  });
}

/**
 * 导出优惠券领用记录
 */
function exportReceiveRecordApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/receiveRecord/export",
    method: 'GET',
    params: params
  });
}

/**
 * 导入优惠券使用记录（伪造数据）
 */
function importFakeCouponRecordApi(file) {
  var formData = new FormData();
  formData.append('file', file);
  return (0, _request.default)({
    url: "/admin/coupons/receiveRecord/importFake",
    method: 'POST',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 小程序列表自动补全
 */
function companyappAutoListApi(params) {
  return (0, _request.default)({
    url: "/admin/companyapp/autoList",
    method: 'GET',
    params: params
  });
}

/**
 *分页查询优惠券管理的产品列表
 */

function couponsPageApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/page",
    method: 'GET',
    params: params
  });
}

/**
 *优惠券列表
 */

function couponLists(params) {
  return (0, _request.default)({
    url: "/admin/coupons",
    method: 'GET',
    params: params
  });
}

/**
 * 数据分析
 */

function statisticsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(params.couponId, "/statistics"),
    method: 'GET',
    params: params
  });
}

/** 下载优惠券券码 Excel，返回文件下载地址 */
function downloadCouponCodesApi(couponId) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(couponId, "/codes/download"),
    method: 'POST'
  });
}

/** 重试生成优惠券券码 */
function retryGenerateCouponCodesApi(couponId) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(couponId, "/codes/retryGenerate"),
    method: 'POST'
  });
}

/**
 * 查询优惠券的链接信息
 */

function linkInfoApi(couponId) {
  return (0, _request.default)({
    url: "/admin/coupons/linkInfo/".concat(couponId),
    method: 'GET'
  });
}

/**
 * 异常关闭优惠券
 */

function closeCouponsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(params.couponId, "/close"),
    method: 'PUT',
    params: params
  });
}

/**
 * 更新优惠券信息
 */

function updateCouponsApi(data) {
  return (0, _request.default)({
    url: "/admin/coupons",
    method: 'PUT',
    data: data
  });
}

/**
 * 查询优惠券详情
 */

function detailCouponsApi(id) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(id),
    method: 'GET'
  });
  // return new Promise((resolve, reject) => {
  //   setTimeout(() => {
  //     resolve({
  //       applicableRangeType: 1,
  //       couponDiscount: [
  //         {
  //           discount: 2,
  //           threshold: 10,
  //         },
  //       ],
  //       a:1,
  //       b:2,
  //       c:3,
  //       d:4,
  //       e:5,
  //       f:6,
  //       g:7,
  //       h:8,
  //       i:9,
  //       j:10,
  //       k:11,
  //       l:12,
  //     });
  //   }, 500);
  // });
}

/**
 * 删除优惠券
 */

function deleteCouponsApi(id) {
  return (0, _request.default)({
    url: "/admin/coupons/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 创建优惠券
 */

function createCouponsApi(data) {
  return (0, _request.default)({
    url: "/admin/coupons",
    method: 'POST',
    data: data
  });
}

/**
 * 优惠券列表
 */

function couponslistApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons",
    method: 'GET',
    params: params
  });
}

/**
 * 获取券类型字典
 */
function getVoucherTypeDictApi() {
  return (0, _request.default)({
    url: "/admin/coupons/voucherTypeDict",
    method: 'GET'
  });
}

/**
 * 获取商品类型字典（可使用场景）
 */
function getProductTypeDictApi() {
  return (0, _request.default)({
    url: "/admin/coupons/productTypeDict",
    method: 'GET'
  });
}

/**
 * SKU分页列表
 */
function skuListApi(data) {
  var params = _objectSpread({}, data);
  if (params.showCateId) {
    params.showCateId = params.showCateId.join(',');
  }
  return (0, _request.default)({
    url: "/admin/store/sku/list",
    method: 'GET',
    params: params,
    paramsSerializer: function paramsSerializer(currentParams) {
      return (0, _index.param)(currentParams);
    }
  });
}

/**
 * 查询客户下拉列表
 */

function getCustomersApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/customerList",
    method: 'GET',
    params: params
  });
}

/**
 * 获取券包列表
 */
function couponPackageListApi(params) {
  return (0, _request.default)({
    url: "/admin/coupon/packages",
    method: 'GET',
    params: params
  });
}

/**
 * 获取券包详情
 */
function couponPackageDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(id),
    method: 'GET'
  });
}

/**
 * 创建券包
 */
function createCouponPackageApi(data) {
  return (0, _request.default)({
    url: "/admin/coupon/packages",
    method: 'POST',
    data: data
  });
}

/**
 * 更新券包
 */
function updateCouponPackageApi(id, data) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(id),
    method: 'PUT',
    data: data
  });
}

/**
 * 删除券包
 */
function deleteCouponPackageApi(id) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(id),
    method: 'DELETE'
  });
}

/**
 * 获取所有券包列表（用于下拉框）
 */
function getAllCouponPackagesApi() {
  return (0, _request.default)({
    url: "/admin/coupon/packages/all",
    method: 'GET'
  });
}

/**
 * 获取券包关联的优惠券
 */
function couponPackageRelationsApi(packageId, params) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(packageId, "/coupons"),
    method: 'GET',
    params: params
  });
}

/**
 * 添加优惠券到券包
 */
function addCouponToPackageApi(packageId, data) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(packageId, "/coupons"),
    method: 'POST',
    data: data
  });
}

/**
 * 从券包移除优惠券
 */
function removeCouponFromPackageApi(packageId, couponId) {
  console.log('API call params:', {
    packageId: packageId,
    couponId: couponId
  });
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(packageId, "/coupons/").concat(couponId),
    method: 'DELETE'
  });
}

/**
 * 检查券包是否可删除
 */
function checkPackageDeletableApi(id) {
  return (0, _request.default)({
    url: "/admin/coupon-packages/".concat(id, "/check-deletable"),
    method: 'GET'
  });
}

/**
 * 更新券包中单个优惠券发放张数
 */
function updateCouponQuantityApi(packageId, couponId, quantity) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(packageId, "/coupons/").concat(couponId, "/quantity"),
    method: 'PUT',
    data: {
      quantity: quantity
    }
  });
}

/**
 * 批量更新券包中优惠券发放张数
 */
function batchUpdateCouponQuantitiesApi(packageId, items) {
  return (0, _request.default)({
    url: "/admin/coupon/packages/".concat(packageId, "/coupons/quantities"),
    method: 'PUT',
    data: {
      items: items
    }
  });
}

/**
 * 获取一卡通商品下拉列表（SPU），支持 keyword 搜索
 */
function getOneCardProductsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/oneCardProducts",
    method: 'GET',
    params: params
  });
}

/**
 * 获取自营卡商品下拉列表
 */
function getSelfOperatedCardProductsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/selfOperatedCardProducts",
    method: 'GET',
    params: params
  });
}

/**
 * 获取在线点餐品牌下拉列表
 */
function getMealBrandsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/mealBrands",
    method: 'GET',
    params: params
  });
}

/**
 * 获取核销门店商家下拉列表
 */
function getVerificationMerchantsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/verificationMerchants",
    method: 'GET',
    params: params
  });
}

/**
 * 获取核销门店下拉列表
 */
function getVerificationStoresApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/verificationStores",
    method: 'GET',
    params: params
  });
}

/**
 * 获取仁寿网店商家下拉列表（只返回有网店的商家）
 */
function getRenshouMerchantsApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/renshouMerchants",
    method: 'GET',
    params: params
  });
}

/**
 * 获取入驻商家门店下拉列表（只返回网店类型）
 */
function getRenshouStoresApi(params) {
  return (0, _request.default)({
    url: "/admin/coupons/renshouStores",
    method: 'GET',
    params: params
  });
}

/**
 * 获取加油门店列表（智慧油客）
 */
function getStationListApi() {
  var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _request.default)({
    url: "/admin/immediate-activity/getStationList",
    method: 'GET',
    params: {
      keyword: keyword
    }
  });
}